import { ChartSeries } from './chart';
import { ChartAxis } from './axis';
import { QueryFilter, QuerySort } from '@softline/core';

export class ChartRef<TRow extends object> {
  readonly axes: ChartAxis[] = [];
  readonly series: ChartSeries<TRow>[] = [];
  readonly filter: QueryFilter<TRow>[] = [];
  readonly sort: QuerySort<TRow>[] = [];

  createSeries(series: ChartSeries<TRow>): void {
    this.series.push(series);
  }

  createAxis(axis: ChartAxis) {
    this.axes.push(axis);
  }

  addFilter(filter: QueryFilter<TRow>): void {
    this.filter.push(filter);
  }

  addSort(sort: QuerySort<TRow>) : void{
    this.sort.push(sort);
  }
}
